/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'

import Button from 'components/commons/button'

const AdminFormModal = ({ adminRoleChange, onClose, onSubmit }: any) => {
  const [newAdminEmail, setNewAdminEmail] = useState('')

  useEffect(() => {
    return () => setNewAdminEmail('')
  }, [])

  const changeText = (e: any) => {
    setNewAdminEmail(e.target.value)
  }

  const submit = (e: any) => {
    e.preventDefault()
    onSubmit(newAdminEmail, adminRoleChange)
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
            <form onSubmit={submit}>
              <div className='relative px-8 pt-8 flex-auto space-y-6 md:mr-10 lg:mr-10'>
                <div className='flex flex-row items-center space-x-2'>
                  <p>{adminRoleChange ? 'New' : 'Remove'} Admin Email:</p>
                  <input
                    className='border-2 rounded-lg p-2'
                    value={newAdminEmail}
                    onChange={changeText}
                    required={true}
                  />
                </div>
              </div>
              <div className='flex items-center p-8 border-slate-200 rounded-b space-x-4'>
                <Button
                  onClick={() => onClose('admin-role-modal')}
                  className='bg-gray-200 font-semibold border px-6'
                >
                  Cancel
                </Button>
                <Button
                  type='submit'
                  className='border border-blue-500 bg-blue-500 text-white font-semibold'
                >
                  {adminRoleChange ? 'Add New' : 'Remove'} Admin
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </>
  )
}

export default AdminFormModal
